export function StatusPill({ status }: { status: 'Active' | 'Inactive' }) {
  const on = status === 'Active'
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-[3px] text-[12px] font-medium"
      style={{
        color: on ? 'var(--v1-ok)' : 'var(--v1-off)',
        background: on ? 'var(--v1-ok-bg)' : 'var(--v1-off-bg)',
      }}
    >
      <span className="size-1.5 rounded-full" style={{ background: 'currentColor' }} />
      {status}
    </span>
  )
}
